export default __webpack_public_path__ + "static/media/banner_.a666e451.png";